import "../style.scss";
import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import logo from "../img/logo.png";

const boxStyle = {
  backgroundColor: "#f9f9f9",
  padding: "25px",
  borderRadius: "8px",
  marginBottom: "30px",
};

const sectionTitle = {
  color: "#7a3260",
  fontSize: "1.3rem",
  margin: "0 0 15px 0",
  fontWeight: 500,
};

const paragraph = {
  lineHeight: 1.8,
  color: "#444",
  margin: "0 0 15px 0",
};

const list = {
  lineHeight: 1.8,
  color: "#444",
  margin: "0 0 15px 0",
  paddingLeft: "20px",
};

const linkStyle = { color: "#7a3260" };

export default function Impressum() {
  useEffect(() => {
    const openIcon = document.querySelector(".fa-bars");
    const closeIcon = document.querySelector(".close-nav");
    const mobileBG = document.querySelector(".mobile-bg");
    const mobileNav = document.querySelector(".mobile-nav");
    const navItem = document.querySelector(".nav-item");

    const handleMenuToggle = () => {
      if (mobileBG && mobileNav && openIcon) {
        mobileBG.classList.toggle("display-none");
        mobileNav.classList.remove("slide-out");
        mobileNav.classList.toggle("slide-in");
        openIcon.classList.toggle("display-none");
      }
    };

    const handleCloseMenu = () => {
      if (mobileBG && mobileNav && openIcon) {
        mobileNav.classList.remove("slide-in");
        mobileNav.classList.add("slide-out");

        setTimeout(() => {
          mobileBG.classList.add("display-none");
          openIcon.classList.remove("display-none");
        }, 500);
      }
    };

    if (openIcon) openIcon.addEventListener("click", handleMenuToggle);
    if (closeIcon) closeIcon.addEventListener("click", handleCloseMenu);
    if (navItem) navItem.addEventListener("click", handleCloseMenu);

    return () => {
      if (openIcon) openIcon.removeEventListener("click", handleMenuToggle);
      if (closeIcon) closeIcon.removeEventListener("click", handleCloseMenu);
      if (navItem) navItem.removeEventListener("click", handleCloseMenu);
    };
  }, []);

  return (
    <>
      <div className="mobile-bg display-none">
        <ul className="mobile-nav">
          <li
            className="nav-item"
            style={{ padding: "15px 20px", marginTop: "70px" }}
          >
            <a
              href="/"
              style={{
                color: "#fff",
                textDecoration: "none",
                fontSize: "18px",
                display: "block",
                fontWeight: "500",
              }}
            >
              Zurück
            </a>
          </li>
        </ul>
        <div
          className="close-nav"
          style={{
            backgroundColor: "transparent",
            width: "100%",
            height: "100%",
          }}
        ></div>
      </div>

      <header style={{ top: "0px" }} className="scrolled">
        <nav className="container">
          <a href="/" className="logo-link">
            <img src={logo} alt="" className="logo-img" />
          </a>

          <i
            style={{ paddingRight: "20px", color: "#7a3260" }}
            className="fas fa-bars"
          >
            <FontAwesomeIcon
              style={{ color: "#7a3260", cursor: "pointer" }}
              icon={icon({ name: "bars", style: "solid" })}
            />
          </i>
          <ul>
            <li>
              <a href="/" className="nav-link">
                Zurück
              </a>
            </li>
          </ul>
        </nav>
      </header>

      <div
        className="container"
        style={{ padding: "100px 50px", paddingBottom: "50px" }}
      >
        <h1
          style={{
            color: "#7a3260",
            textAlign: "left",
            padding: "20px 0",
            fontSize: "2.2rem",
            fontWeight: 600,
            marginBottom: "30px",
            borderBottom: "2px solid #f0f0f0",
          }}
        >
          Impressum
        </h1>

        <div style={boxStyle}>
          <p style={{ ...paragraph, margin: 0 }}>
            <strong>ELEV8ION</strong>
            <br />
            Kärntnerstraße 568c/4
            <br />
            8054 Seiersberg-Pirka
            <br />
            Österreich
          </p>
        </div>

        <div style={boxStyle}>
          <h3 style={sectionTitle}>Kontakt</h3>
          <p style={{ ...paragraph, margin: 0 }}>
            <strong>E-Mail:</strong>{" "}
            <a href="mailto:elev8ionhelp@gmail.com" style={linkStyle}>
              elev8ionhelp@gmail.com
            </a>
          </p>
        </div>

        <h2
          style={{
            color: "#444",
            textAlign: "left",
            padding: "40px 0 20px 0",
            fontSize: "1.8rem",
          }}
        >
          Datenschutzerklärung
        </h2>

        <h3 style={{ ...sectionTitle, marginTop: "10px" }}>
          1. Verantwortlicher
        </h3>
        <p style={paragraph}>
          Philipp Auer
          <br />
          Kärntnerstraße 568c/4
          <br />
          8054 Seiersberg-Pirka
          <br />
          Österreich
          <br />
          E-Mail:{" "}
          <a href="mailto:elev8ionhelp@gmail.com" style={linkStyle}>
            elev8ionhelp@gmail.com
          </a>
        </p>

        <h3 style={sectionTitle}>2. Allgemeines</h3>
        <p style={paragraph}>
          Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges
          Anliegen. Wir verarbeiten Ihre Daten ausschließlich auf Grundlage der
          gesetzlichen Bestimmungen (DSGVO, DSG, TKG).
        </p>
        <p style={paragraph}>
          Diese Datenschutzerklärung informiert über Art, Umfang und Zweck der
          Verarbeitung personenbezogener Daten im Rahmen der Nutzung der
          ELEV8ION Plattform und der zugehörigen mobilen Anwendungen.
        </p>

        <h3 style={sectionTitle}>3. Verarbeitete Daten</h3>
        <p style={paragraph}>
          Im Rahmen der Nutzung von ELEV8ION können folgende personenbezogene
          Daten verarbeitet werden:
        </p>

        <h4 style={{ color: "#444", marginTop: "20px", marginBottom: "10px" }}>
          Stammdaten
        </h4>
        <ul style={list}>
          <li>Vor- und Nachname</li>
          <li>E-Mail-Adresse</li>
          <li>Geschlecht</li>
          <li>Geburtsdatum</li>
        </ul>

        <h4 style={{ color: "#444", marginTop: "20px", marginBottom: "10px" }}>
          Trainings- und Profildaten
        </h4>
        <ul style={list}>
          <li>Körpergröße</li>
          <li>Körpergewicht</li>
          <li>Trainingsziele</li>
          <li>Trainingsfortschritte</li>
          <li>Herzfrequenzzonen</li>
          <li>Trainingspläne</li>
          <li>Trainingseinträge</li>
          <li>Feedback zu Trainingseinheiten</li>
          <li>Profilbild und hochgeladene Bilder</li>
        </ul>

        <h4 style={{ color: "#444", marginTop: "20px", marginBottom: "10px" }}>
          Technische Daten
        </h4>
        <ul style={list}>
          <li>Geräteinformationen</li>
          <li>App-Version</li>
          <li>Betriebssystem</li>
          <li>Geräte-IDs und Push-Token</li>
          <li>Nutzungsstatistiken</li>
        </ul>

        <h3 style={sectionTitle}>4. Zweck der Datenverarbeitung</h3>
        <p style={paragraph}>Die Verarbeitung erfolgt zur:</p>
        <ul style={list}>
          <li>Bereitstellung der Plattform</li>
          <li>Verwaltung von Benutzerkonten</li>
          <li>Erstellung und Verwaltung von Trainingsplänen</li>
          <li>Betreuung durch Trainer</li>
          <li>Analyse und Verbesserung der Anwendung</li>
          <li>Fehlerbehebung und Systemsicherheit</li>
        </ul>

        <h3 style={sectionTitle}>5. Trainerzugriffe</h3>
        <p style={paragraph}>
          Trainer können ausschließlich auf Daten jener Benutzer zugreifen, die
          ihnen innerhalb der Plattform zugewiesen wurden oder die einer
          Zusammenarbeit ausdrücklich zugestimmt haben.
        </p>
        <p style={paragraph}>
          Trainer sind verpflichtet, personenbezogene Daten vertraulich zu
          behandeln und ausschließlich für Betreuungszwecke zu verwenden.
        </p>

        <h3 style={sectionTitle}>6. Fotos und Uploads</h3>
        <p style={paragraph}>
          Sie können freiwillig ein Profilbild und Bilder zu Trainings
          hochladen. Diese Dateien werden in Firebase Storage gespeichert und
          sind für den zugewiesenen Trainer sichtbar. Mit der Löschung des
          Kontos werden die hochgeladenen Bilder gelöscht.
        </p>
        <p style={paragraph}>
          Auf Kamera und Galerie wird nur zugegriffen, wenn Sie ein Bild
          auswählen. Eine automatische Erfassung von Fotos findet nicht statt.
        </p>

        <h3 style={sectionTitle}>7. Firebase und Google-Dienste</h3>
        <p style={paragraph}>
          Für den Betrieb von ELEV8ION werden Dienste der Google Ireland Limited
          eingesetzt.
        </p>

        <h4 style={{ color: "#444", marginTop: "20px", marginBottom: "10px" }}>
          Firebase Authentication
        </h4>
        <p style={paragraph}>
          Zur Benutzeranmeldung und Kontoverwaltung. Die Anmeldung ist mit
          E-Mail und Passwort, über Google Sign-In oder über Apple Sign-In
          möglich.
        </p>

        <h4 style={{ color: "#444", marginTop: "20px", marginBottom: "10px" }}>
          Cloud Firestore
        </h4>
        <p style={paragraph}>
          Zur Speicherung von Stammdaten, Trainingsdaten und Plänen.
        </p>

        <h4 style={{ color: "#444", marginTop: "20px", marginBottom: "10px" }}>
          Firebase Storage
        </h4>
        <p style={paragraph}>
          Zur Speicherung von Profilbildern sowie Trainings- und Übungsbildern,
          die Sie selbst hochladen.
        </p>

        <h4 style={{ color: "#444", marginTop: "20px", marginBottom: "10px" }}>
          Firebase Analytics
        </h4>
        <p style={paragraph}>
          Zur Erfassung der App-Nutzung. Erhoben werden Nutzungsereignisse
          sowie Geräte- und App-Instanz-IDs. Eine Werbe-ID (AD_ID) wird nicht
          verwendet.
        </p>

        <h4 style={{ color: "#444", marginTop: "20px", marginBottom: "10px" }}>
          Firebase Cloud Messaging (FCM)
        </h4>
        <p style={paragraph}>
          Für Push-Benachrichtigungen innerhalb der App. Dabei wird ein
          Geräte-Token verarbeitet.
        </p>

        <p style={paragraph}>
          Dabei können Daten auf Servern innerhalb und außerhalb der
          Europäischen Union verarbeitet werden.
        </p>
        <p style={paragraph}>
          Weitere Informationen:{" "}
          <a
            href="https://firebase.google.com/support/privacy"
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
          >
            firebase.google.com/support/privacy
          </a>
        </p>

        <h3 style={sectionTitle}>8. Rechtsgrundlagen</h3>
        <p style={paragraph}>Die Verarbeitung erfolgt auf Grundlage von:</p>
        <ul style={list}>
          <li>Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</li>
          <li>Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)</li>
          <li>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)</li>
        </ul>
        <p style={paragraph}>
          Soweit Gesundheits- oder Trainingsdaten verarbeitet werden, erfolgt
          dies ausschließlich auf Grundlage der ausdrücklichen Einwilligung der
          betroffenen Person.
        </p>

        <h3 style={sectionTitle}>9. Speicherdauer</h3>
        <p style={paragraph}>
          Kontodaten werden bis zur Löschung des Kontos gespeichert.
        </p>
        <p style={paragraph}>
          Nach der Löschung des Kontos werden die personenbezogenen Daten und
          die hochgeladenen Bilder gelöscht. Länger gespeichert bleiben nur
          jene Daten, die gesetzliche Aufbewahrungspflichten verlangen.
        </p>
        <p style={paragraph}>
          Die Kontolöschung ist in der App sowie über{" "}
          <a href="https://elev8ion.at/konto-loeschen" style={linkStyle}>
            https://elev8ion.at/konto-loeschen
          </a>{" "}
          möglich.
        </p>

        <h3 style={sectionTitle}>10. Kontolöschung</h3>
        <p style={paragraph}>
          Sie können Ihr Konto in der App im Profil löschen. Alternativ
          fordern Sie die Löschung über{" "}
          <a href="https://elev8ion.at/konto-loeschen" style={linkStyle}>
            https://elev8ion.at/konto-loeschen
          </a>{" "}
          an und geben dort die E-Mail-Adresse des Kontos an.
        </p>
        <p style={paragraph}>Gelöscht werden:</p>
        <ul style={list}>
          <li>das Konto</li>
          <li>Profildaten</li>
          <li>Trainingsdaten</li>
          <li>hochgeladene Bilder</li>
        </ul>
        <p style={paragraph}>
          In der App erfolgt die Löschung unmittelbar nach der Bestätigung im
          Profil. Eine Anfrage über die Website wird nach Prüfung umgesetzt.
          Konto, Profildaten, Trainingsdaten und hochgeladene Bilder werden
          dabei gelöscht. Daten, für die eine gesetzliche Aufbewahrungspflicht
          besteht, bleiben für die Dauer dieser Pflicht gespeichert.
        </p>

        <h3 style={sectionTitle}>11. Rechte der betroffenen Personen</h3>
        <p style={paragraph}>Sie haben jederzeit das Recht auf:</p>
        <ul style={list}>
          <li>Auskunft</li>
          <li>Berichtigung</li>
          <li>Löschung</li>
          <li>Einschränkung der Verarbeitung</li>
          <li>Datenübertragbarkeit</li>
          <li>Widerspruch</li>
          <li>Widerruf einer Einwilligung</li>
          <li>Beschwerde bei der Datenschutzbehörde</li>
        </ul>
        <p style={paragraph}>
          Österreichische Datenschutzbehörde:
          <br />
          Barichgasse 40-42
          <br />
          1030 Wien
          <br />
          <a
            href="https://www.dsb.gv.at"
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
          >
            www.dsb.gv.at
          </a>
        </p>

        <h3 style={sectionTitle}>12. Kontakt</h3>
        <p style={paragraph}>
          Bei Fragen zum Datenschutz wenden Sie sich bitte an:{" "}
          <a href="mailto:elev8ionhelp@gmail.com" style={linkStyle}>
            elev8ionhelp@gmail.com
          </a>
        </p>
        <p style={paragraph}>Stand: Oktober 2026</p>
      </div>

      <footer>
        <div className="container">
          <ul className="flex-row">
            <li>
              <a href="/">Zurück</a>
            </li>
          </ul>
          <ul className="flex-row">
            <li>
              <a
                href="https://play.google.com/store/apps/details?id=com.trainingsapp.trainingsapp"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-google-play">
                  <FontAwesomeIcon
                    icon={icon({ name: "google-play", style: "brands" })}
                  />
                </i>
              </a>
            </li>
            <li>
              <a
                href="https://apps.apple.com/at/app/elev8ion/id1645771356"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-app-store-ios">
                  <FontAwesomeIcon
                    icon={icon({ name: "app-store-ios", style: "brands" })}
                  />
                </i>
              </a>
            </li>
          </ul>
          <p>{"© 2025 ELEV8ION"}</p>
        </div>
      </footer>
    </>
  );
}
